import configureAppStore from './redux_store'; // Your function from the other file
export const store = configureAppStore();